import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import styled from 'styled-components'
import { Text } from '../../elements/Text'
import BasicLayout from '../../layouts/BasicLayout'

interface IProps extends RouteComponentProps<any> {}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 100px 12px;
  .title {
    margin-bottom: 16px;
  }
`
const ContentContainer = styled.div`
  strong {
    font-weight: 900;
  }
  a {
    color: #ff730e;
  }
`
class ChangesPage extends React.Component<IProps> {
  public render() {
    return (
      <BasicLayout noToast={true}>
        <Container>
          <Text.HighlightMain>重大服務變更</Text.HighlightMain>
          <br />
          <ContentContainer>
            Hello 各位 Qraft 匠說的朋友們，我們要來宣布一個重要消息了！
            <br />
            很感謝你們對於 Qraft 匠說的支持，Qraft
            匠說團隊從平台上線到現在收到了你們非常多的意見與回饋，
            <br />
            再多言語都無法表示 Qraft 對你們的感激，因為有你們，Qraft
            才能一直走到現在。
            <br />
            我們一直持續蒐集著你們的意見，也陸續進行了一些細部的調整，
            <br />
            即將在2019年2月初著手進行一次大型的改版整合，我們會大幅優化現在的體驗細節、效能，
            <br />
            <br />
            <strong>
              我們將加入 TeachCake 團隊共同努力，
              <br />
              預計透過 3
              個月的時間，開放一個更能讓講者深度經營的個人品牌，能貫徹整個整個知識服務和經營的網站平台，
              <br />
            </strong>
            <br />
            且會保障原有內容能在改版的過程中被持續收聽，同時為了更好的服務和體驗，
            <br />
            我們將延後部分課程的上架時間，在這裡也要跟耐心等候我們的朋友與講師，致上我們最誠摯的歉意，
            <br />
            因為我們希望讓使用我們平台的朋友，都有更好的學習品質與服務。
            <br />
            <br />
            會有這樣的改動，是希望能夠實踐我們的初衷，也就是降低知識分享的門檻，讓知識流動是能夠更完整、更貼近知識，
            <br />
            讓每個人身上值得被分享的內容能被他人看見，讓大家從分享中看見甚至提升自己的價值，
            <br />
            台灣很小，但我們用龐大的知識站上世界的舞台。
            <br />
            <br />
            我們誠摯地邀請你們，在 2019年的5月份 上線體驗全新樣貌的 TeachCake，
            <br />
            一起來打造專屬於你們的知識形象吧！ <br />
            <br />
            Qraft 匠說 ,敬上
            <br />
            <br />
            <hr />
            此外，預計受影響的講座如下： 用個人品牌逆轉人生的第1堂大課
            <br />
            <ul>
              <li>* 個人品牌3部曲之1—升溫 </li>
              <li>* 我是如何踏上有效學習之路 </li>
              <li>* UI / 網頁設計專案執行力 - 從自學到企業專案</li>
              <li>* 探討現代求職新思路--給在職涯中感到迷惘的你</li>
              <li>* 溝通協作力，未來人才最重要的軟實力（職場篇）</li>
            </ul>
            如有購買以上講座者，Qraft
            將與各位講師進行協調，近期這週將會個別聯繫購買者
            <br />
            並保障購買者權益不受損，可以持續收聽，造成各位的不便深感抱歉
            <br />
            若有其他問題歡迎
            <a href="mailto:us@qraft.app">與我們聯絡</a>
            ，我們將在1天內回覆您
            <br />
          </ContentContainer>
        </Container>
      </BasicLayout>
    )
  }
}

export default ChangesPage



// WEBPACK FOOTER //
// ./src/pages/ChangesPage/index.tsx